import {
  altChip,
  buttonDeleteAnswer,
  buttonFixAnswer,
  buttonPreserveAnswer,
} from "_constants";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { getReportTypeIcon } from "utils";

export const CardResolutionType = ({
  title,
  subtitle,
  helpText,
  callback,
  type,
}: {
  title: string;
  subtitle: string;
  helpText: string;
  callback: Function;
  type: "correct" | "wrong" | "partially_wrong";
}) => {
  return (
    <div className="card-resolution-type flex-container column">
      <img
        src={getReportTypeIcon(type)}
        alt={altChip}
        className="w-52 h-52 margin-bottom-18"
      />
      <span className="text-base-bold">{title}</span>
      <span className="text-sm margin-top-4">{subtitle}</span>
      <Divider color="#E5E7EB" />
      <div className="flex-container column height-100">
        <small className="text opacity-60 flex-1">{helpText}</small>
        <Button
          style={{ height: "40px" }}
          type="button"
          severity={
            type === "correct"
              ? "success"
              : type === "wrong"
              ? "danger"
              : "warning"
          }
          label={
            type === "correct"
              ? buttonPreserveAnswer
              : type === "wrong"
              ? buttonDeleteAnswer
              : buttonFixAnswer
          }
          onClick={() => callback()}
        />
      </div>
    </div>
  );
};
